import gql from 'graphql-tag';

export default gql`
	query SelectDate {
		selectDate @client {
			isCompleted
		}
	}
`;
